import React, {useContext} from "react";
import {StateContext} from "../../../../App";
import {
  Card,
  CardBody,
  Col,
  DropdownItem,
  InputGroup,
  InputGroupAddon,
  Row,
  Button,
  Input,
  CustomInput,
  Badge,
  UncontrolledDropdown, DropdownToggle, DropdownMenu
} from "reactstrap";
import {observer} from "mobx-react-lite";
import {FormattedMessage, useIntl} from "react-intl";
import * as Icon from "react-feather";
import ScanbuyTable, {TableColumn} from "../../../tables/ScanbuyTable";
import TableActionsDropdown from "../../../tables/TableActionsDropdown";
import GroupSelect from "../../../elements/groups/GroupSelect";
import dayjs from 'dayjs';
import DeleteParameterSetState from "../delete//DeleteParameterSetState";
import DeleteParameterSetView from "../delete/DeleteParameterSetView";
import GenericModal from "../../../elements/modal/GenericModal";
import {useRouterStore} from "mobx-state-router";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faAngleDoubleDown, faAngleDoubleUp, faSlidersH} from "@fortawesome/free-solid-svg-icons";
import AdvancedConfFilterSelect from "../../../elements/filters/AdvancedConfFilterSelect";
import {buildDimensionFilters} from "../../../../utils/buildDimensionFilters";
import TagSelect from "../../../elements/tags/TagSelect";
import {
  ADVANCED_SETTINGS_MANAGE_SET,
  formConstants
} from "../../../../utils/constants";
import {createdByColumn, updatedByColumn} from "../../../tables/TableColumns";
import OptionalColumnsDropdown from "../../../elements/dropdown/OptionalColumnsDropdown";
import {getSnapshot} from "mobx-state-tree";
import TagFilterSelect from "../../../elements/filters/TagFilterSelect";
import GroupFilterSelect from "../../../elements/filters/GroupFilterSelect";
import {requiredRolesCheck} from "../../../../utils/requiredRolesCheck";
import ResetButton from "../../../ResetButton";
import {buildColumnsWithOptionalSupport} from "../../../../utils/optionalColumnsHelper";


export const buildParameterSetsColumns = (routerStore, parameterSetsListViewState) => {
  const {rootStore} = routerStore.options;
  const visible = new Set(parameterSetsListViewState.optionalColumns);
  const c1 = TableColumn.create({name: 'ParameterSet', property: 'parameterSet'});
  c1.setSelector((row) => row.label);
  const c2 = TableColumn.create({name: 'Default', property: 'isDefault'});
  //c2.setSelector((row)=> row.isDefault.toString());

  const c3 = TableColumn.create({
    name: 'Tag(s)', property: 'tags', hide: 'sm'
  });
  c3.setSelector((row) => {
    return row.tags;
  });
  c3.setCell((row) => {
    const tags = row?.tags?.flatMap((t) => {
      return {uuid: t?.uuid, name: t?.name, color: t?.uiStyleConfigs?.color || 'info'}
    });
    return (<div>
      {tags.map((tag, index) => (<Badge
        key={index}
        color="info"
        className="badge-pill mr-1 mb-1"
      >
        {tag.name}
      </Badge>))}
    </div>)
  })

  const createdBy = createdByColumn();
  const updatedBy = updatedByColumn();
  const c4 = TableColumn.create({
    name: 'Create Date', property: 'created', width: '15%', hide: 'sm', sortable: true, sortField: 'createdAt',
  });
  c4.setSelector((row) => {
    // console.log(row)
    console.log("row", row);
    const {createdAt} = row || {};
    const formattedCreateDate = dayjs(createdAt).format('YYYY-MM-DD HH:mm:ss');
    return formattedCreateDate;
  });

  const c5 = TableColumn.create({
    name: 'Last Modified', property: 'updated', width: '15%', hide: 'sm', sortable: true, sortField: 'updatedAt',
  });
  c5.setSelector((row) => {
    // console.log(row)
    const {updatedAt} = row || {};
    const formattedUpdateDate = dayjs(updatedAt).format('YYYY-MM-DD HH:mm:ss');
    return formattedUpdateDate;
  });
  const actionColl = TableColumn.create({
    name: 'Actions', property: 'actions', button: true, allowOverflow: true, ignoreRowClick: true
  });
  actionColl.setCell((row) => (
    <TableActionsDropdown actionsList={[
      <DropdownItem key={'view/' + row.uuid}
                    onClick={() => {
                      routerStore.goTo('editParameterSet', {
                        params: {uuid: row.uuid},
                        queryParams: {isEditable: 'false'}
                      });
                    }}
      >
        <Icon.FileText/>View
      </DropdownItem>,
      ...(row.isEditable ? [
      <DropdownItem key={'edit/' + row.uuid}
                    onClick={() => {
                      routerStore.goTo('editParameterSet', {
                        params: {uuid: row.uuid},
                      });
                    }}
      >
        <Icon.Edit/>Edit</DropdownItem>]: []),
      ...(row.isEditable ? [
      <DropdownItem key={'new'} onClick={() => {
        rootStore.rootUiStore.addCloneToCache(`clone-parameterSet:${row.uuid}`,row);
        routerStore.goTo('createParameterSet',{
          queryParams: {q: row.uuid}
        })
      }}><Icon.Copy/>&nbsp;<FormattedMessage id="listCodes.actions.dropdown.clone.defaultMessage"/></DropdownItem>]: []),
      ...(row.isEditable ? [
      <DropdownItem key={row.uuid} value={"Delete " + row.uuid} className="align-text-bottom"
                    onClick={() => {

                      const userRoles = rootStore?.userRoles
                      if(!requiredRolesCheck(ADVANCED_SETTINGS_MANAGE_SET, userRoles)) return

                      const componentStore = DeleteParameterSetState.create(
                        {
                          parameterSetName: row.name,
                          title: `Delete ${row.name ? row.name : ""}`,
                          uuid: row.uuid
                        });
                      rootStore.rootUiStore.attachPageState('deleteParameterSetStore', componentStore)

                      componentStore.setToggleListener(parameterSetsListViewState.modalStore.toggle)
                      componentStore.setRefreshListener(parameterSetsListViewState.refresh)
                      parameterSetsListViewState.handleRowClick(row, componentStore, DeleteParameterSetView);
                    }}> <Icon.Delete/>&nbsp;<FormattedMessage id="listCodes.actions.dropdown.delete.defaultMessage"/>
      </DropdownItem>]:[])
    ]}/>
  ))

  const allColumns = [

    c1,
    // c2,
    c3,
    createdBy,
    updatedBy,
    c4,
    c5,
    actionColl,
  ];
  return buildColumnsWithOptionalSupport(allColumns, parameterSetsListViewState, rootStore);
}

const ParameterSetsListView = observer(({parameterSetsListViewState}) => {
    const routerStore = useRouterStore();
    const intl = useIntl();
    const stateContext = useContext(StateContext);

    const optionalColumns = stateContext?.appConfigs?.configs?.optional_columns || ['updatedBy'];

    // Get column name mapping from state
    const columnNameMapping = parameterSetsListViewState.columnNameMapping || {};
    console.log("parameterSetStore", parameterSetsListViewState.columns);
    console.log("parameterSetStore", parameterSetsListViewState.store);
    //TODO: PATTERN VIOLATION - setOnSelectChanges called on every render
    // See correct pattern: setOnSelectChanges() in src/routes/codes/index.js onEnter
    parameterSetsListViewState.setOnSelectChanges()
    //TODO: PATTERN VIOLATION - Multiple filter setters called on every render (lines 194-198)
    // See correct pattern: setOnSelectChanges() in src/routes/codes/index.js onEnter
    parameterSetsListViewState?.advFilterSelectState?.setEmails(parameterSetsListViewState.listModel?.filters?.users);
    parameterSetsListViewState?.tagFilterSelectState?.setTags(parameterSetsListViewState.listModel?.filters?.tags);
    parameterSetsListViewState?.filterGroup && parameterSetsListViewState?.groupFilterSelectState?.setGroups(parameterSetsListViewState?.listModel?.filters?.groups)
    parameterSetsListViewState?.dimensionSelectViewState?.setFilteredDimensions(parameterSetsListViewState?.listModel?.filters.dimensions);
    parameterSetsListViewState?.loadFiltersFromSessionStorage()

    const customStyles = {
      headRow: {
        style: {
          border: 'none',
        },
      },
      headCells: {
        style: {
          color: '#202124',
          fontSize: '14px',
        },
      },
      rows: {
        highlightOnHoverStyle: {
          backgroundColor: 'rgb(230, 244, 244)',
          borderBottomColor: '#FFFFFF',
// borderRadius: '5px',
          outline: '1px solid #FFFFFF',
        },
      },
      pagination: {
        style: {
          border: 'none',
        },
      },
    }

    return (
      <>
        <Card>
          <CardBody>
            <Row>
              <Col className="d-flex justify-content-end list-view-actions-container">
                {parameterSetsListViewState.isFilterVisible ? (
                  <Button
                    id="codelist-dropdown-open"
                    color="primary"
                    onClick={() => parameterSetsListViewState.toggleFilterVisible()}
                  >
                    <FontAwesomeIcon icon={faAngleDoubleUp} />
                  </Button>
                ) : (
                  <Button
                    id="codelist-dropdown-closed"
                    color="primary"
                    onClick={() => parameterSetsListViewState.toggleFilterVisible()}
                  >
                    <FontAwesomeIcon icon={faAngleDoubleDown} />
                  </Button>
                )}

                <OptionalColumnsDropdown
                  listViewState={parameterSetsListViewState}
                  buildColumnsFunction={buildParameterSetsColumns}
                  idPrefix="parametersets-col"
                />
              </Col>
            </Row>
            {parameterSetsListViewState?.isFilterVisible && <>
              <Row>
                <Col sm={5}>
                  <InputGroup className="mb-3">
                    <InputGroupAddon addonType="prepend">
                      {intl.formatMessage({id: "filterByGroups.defaultMessage"})}
                    </InputGroupAddon>
                    {/*<CodeOwnerFilterSelect codeOwnerFilterSelectState={designsListState.codeOwnerFilterSelectState}/>*/}
                    {/*<GroupSelect groupSelectStore={parameterSetsListViewState.groupSelectStore} multi={true}/>*/}
                    <GroupFilterSelect groupFilterSelectState={parameterSetsListViewState.groupFilterSelectState}/>
                  </InputGroup>
                </Col>
                <Col sm={5}>
                  <InputGroup className="mb-3">
                    <InputGroupAddon addonType="prepend">
                      {intl.formatMessage({id: "listCodes.filter.filterName.defaultMessage"})}
                    </InputGroupAddon>
                    <AdvancedConfFilterSelect advFilterSelectState={parameterSetsListViewState.advFilterSelectState}/>
                  </InputGroup>
                </Col>
              </Row>
              <Row className="list-view-row-align-end">
                <Col sm={10}>
                  <Row>
                    {parameterSetsListViewState?.dimensionSelectViewState?.dimensionsEnabled && parameterSetsListViewState?.dimensionSelectViewState?.dimensionSelectStates?.map(dimensionSelectStore => buildDimensionFilters(dimensionSelectStore, 6))}
                  </Row>
                </Col>
                <ResetButton viewState={parameterSetsListViewState}/>
              </Row>
              <Row>
                <Col sm={5}>
                  <InputGroup className="mb-3">
                    <InputGroupAddon addonType="prepend">
                      {intl.formatMessage({id: "listCodes.searchInput.defaultMessage"})}
                    </InputGroupAddon>
                    <Input
                      type="text"
                      name="searchInput"
                      placeholder="Search"
                      onChange={parameterSetsListViewState.onSearchChange}
                      value={parameterSetsListViewState.searchTxt}
                    />
                  </InputGroup>
                </Col>
                <Col sm={5}>
                  <InputGroup className="mb-3">
                    <InputGroupAddon addonType="prepend">
                      {intl.formatMessage({id: "listCodes.filterBytags.defaultMessage"})}
                    </InputGroupAddon>
                    {/*<TagSelect tagSelectStore={parameterSetsListViewState?.tagSelectStore}/>*/}
                    <TagFilterSelect tagFilterSelectState={parameterSetsListViewState.tagFilterSelectState}/>
                  </InputGroup>
                </Col>
                <Col sm={1}>
                  <CustomInput
                    type="switch"
                    id="isFilterTypeOR"
                    name="isFilterTypeOR"
                    label={formConstants.Mode.OR}
                    checked={parameterSetsListViewState.isFilterTypeOR}
                    onChange={() => parameterSetsListViewState.selectFilterMethod()}
                  />
                </Col>
                <Col sm={1} className="justify-content-end text-right">
                  <Button color="primary" onClick={() => {
                    routerStore.goTo('createParameterSet', {});
                  }}>
                    <FormattedMessage id="qrDesign.manageList.create.defaultMessage"/>
                  </Button>
                </Col>
              </Row>
            </>}
            <Row>
              <Col>
                {parameterSetsListViewState.listModel.store.list.length ?
                  <ScanbuyTable
                    key={parameterSetsListViewState?.columns.length}
                    columns={parameterSetsListViewState.columns}
                    customStyles={customStyles}
                    store={parameterSetsListViewState.listModel}
                  />
                  :
                  <ScanbuyTable
                    key={parameterSetsListViewState?.columns.length}
                    columns={parameterSetsListViewState.columns}
                    customStyles={customStyles}
                    store={parameterSetsListViewState.listModel}
                    state={parameterSetsListViewState}
                  />
                }
              </Col>
            </Row>
          </CardBody>
        </Card>
        <GenericModal
          modalStore={parameterSetsListViewState.modalStore}
          componentStore={parameterSetsListViewState.modalComponentStore}
          EmbedComponent={parameterSetsListViewState.modalComponent}
        />
      </>
    )
  }
)

export default ParameterSetsListView
